import React from "react";
import * as Popover from "@radix-ui/react-popover";
import { More } from "../../assets/svgs/icons";
import User from "./User";
import { User as TUser } from "../../api/userApi";
import MyAirV2Content from "../../views/myAirV2/containers/ContentContainer";
import getUserState from "../../views/tutorV2/utils/getUserState";

export interface MenuPopoverProps {
  variant?: "expanded" | "collapsed";
  open: boolean;
  onOpenChange: (open: boolean) => void;
  user?: TUser;
  onPurchaseClick?: () => void;
  onItemClick?: (item: string) => void;
}

const MenuPopover: React.FC<MenuPopoverProps> = ({
  variant = "expanded",
  open,
  onOpenChange,
  user,
  onPurchaseClick,
  onItemClick,
}) => {
  const handlePurchaseClick = () => {
    onPurchaseClick?.();
    onOpenChange(false); // 구매하기 클릭 시 팝오버 자동 닫기
  };

  // 메뉴 콘텐츠 컴포넌트 (공통 사용)
  const MenuContent = () => (
    <div className="bg-white box-border flex flex-col items-center min-w-[288px] p-4 rounded-[20px] shadow-[0px_6px_12px_-6px_rgba(0,0,0,0.12),0px_8px_24px_-4px_rgba(0,0,0,0.08)] w-[288px]">
      <MyAirV2Content />
    </div>
  );

  if (variant === "collapsed") {
    return (
      <div className="flex h-20 items-center justify-center w-16">
        <Popover.Root open={open} onOpenChange={onOpenChange}>
          <Popover.Trigger asChild>
            <button className="box-border flex gap-[10px] items-center justify-center p-[18px] relative shrink-0 size-[60px] hover:bg-[#f3e8ff] rounded-full transition-colors">
              <More width={24} height={24} className="rotate-90" />
            </button>
          </Popover.Trigger>

          <Popover.Portal>
            <Popover.Content
              side="top"
              align="start"
              sideOffset={10}
              alignOffset={10}
              className="z-50"
            >
              <MenuContent />
            </Popover.Content>
          </Popover.Portal>
        </Popover.Root>
      </div>
    );
  }

  // expanded variant
  return (
    <div className="h-20 w-full">
      <div className="relative">
        <User
          state={user ? getUserState(user) : "inactive"}
          email={user?.name}
          avatarUrl={""}
          endDate={user?.end_dt}
          showButton={false} // More 버튼 숨김
          onPurchaseClick={handlePurchaseClick}
        />

        <Popover.Root open={open} onOpenChange={onOpenChange}>
          <Popover.Trigger asChild>
            <button className="absolute right-0 top-1/2 -translate-y-1/2 box-border flex gap-[10px] items-center justify-center p-3 shrink-0 size-12 hover:bg-[#f7f7f7] rounded-full transition-colors">
              <More width={24} height={24} className="rotate-90" />
            </button>
          </Popover.Trigger>

          <Popover.Portal>
            <Popover.Content
              side="top"
              align="end"
              sideOffset={10}
              alignOffset={16}
              className="z-50"
            >
              <MenuContent />
            </Popover.Content>
          </Popover.Portal>
        </Popover.Root>
      </div>
    </div>
  );
};

export default MenuPopover;
